import { AutocompleteHintsParams } from '@displate/styleguide/dist/hydra/modules/Autocomplete/types';

import { AthenaClickEvent } from '@/common/hooks/useAthena/athenaEvents';
import { PageConfig } from '@/common/routes/RouteBuilder';

import { createEmptyArtworkContext } from './contexts';
import { searchTrackingStorageManager } from './utils';

interface AutocompletePhraseParameters extends AutocompleteHintsParams {
  pageConfig: PageConfig;
}

export const trackAutocompletePhraseClick = (
  parameters: AutocompletePhraseParameters,
  pushEvent: (event: AthenaClickEvent) => void,
) => {
  pushEvent({
    eventName: 'autocompletePhraseClick',
    eventType: 'click',
    eventParams: createAutocompletePhraseParams(parameters),
    context: createEmptyArtworkContext(parameters.pageConfig.analyticsAthenaName),
  });
};

const createAutocompletePhraseParams = (parameters: AutocompletePhraseParameters) => {
  const { searchQueryId = null } = searchTrackingStorageManager.getItem() || {};

  return {
    phrase: parameters.phrase,
    searchQueryId,
    searchPhrase: parameters.searchPhrase,
    searchPosition: parameters.searchPosition,
    category: parameters.category,
    itemListId: `PT:${parameters.pageConfig.analyticsGaName}|LT:${parameters.listingType}|LF:${parameters.listingFunction}`,
  };
};
